// #3187 APPROVE.4 — the web's read of CLIENT_APPROVAL_ENFORCEMENT_LIVE
// (apps/api/src/services/clientApprovalLifecycle.ts), exposed by the
// unauthenticated GET /client-approval-requests/enforcement (ruling 6564608023).
//
// FAIL CLOSED TO TODAY'S UI: anything but a 200 whose body is exactly
// { live: true } (an error status, a network error, a timeout, a malformed or
// missing body, live as a string) reads as false, so the Client Portal renders
// as it did before APPROVE.4. Every new screen and the removal of the phase
// sign-off card are behind `true`.

import { useEffect, useState } from 'react';
import { apiFetch } from './api';

export const ENFORCEMENT_PATH = '/client-approval-requests/enforcement';
export const ENFORCEMENT_TIMEOUT_MS = 3000;

/** Strict: only a plain object whose `live` is the boolean true. */
export function parseEnforcementBody(body: unknown): boolean {
  return typeof body === 'object' && body !== null && !Array.isArray(body) && (body as { live?: unknown }).live === true;
}

export async function fetchClientApprovalEnforcementLive(timeoutMs = ENFORCEMENT_TIMEOUT_MS): Promise<boolean> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<false>((resolve) => { timer = setTimeout(() => resolve(false), timeoutMs); });
  try {
    return await Promise.race([
      apiFetch<unknown>(ENFORCEMENT_PATH).then(parseEnforcementBody), // a rejection reaches the catch below
      timeout,
    ]);
  } catch {
    return false;
  } finally {
    if (timer) clearTimeout(timer);
  }
}

/** undefined while the answer is pending; then true or false (false on any failure). */
export function useClientApprovalEnforcementLive(): boolean | undefined {
  const [live, setLive] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    let cancelled = false;
    void fetchClientApprovalEnforcementLive().then((v) => { if (!cancelled) setLive(v); });
    return () => { cancelled = true; };
  }, []);
  return live;
}
